<template>
    <div class="page magic-bg dark:text-white">
        <navigation :key="navigationKey"/>
        <div class="bookmark">
            <div class="bookmark-container">
                <div class="bookmark-modal" id="themes_adjustments">
                    <div class="flex flex-row items-center justify-between mb-2">
                        <p class="bookmark-modal-title text-gradient mr-auto">Сортировка</p>
                        <button class="rounded-button" title="Очистить сортировку" @click="ClearParams">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 hover:animate-spin" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                    <div class="form-group ml-2 mt-2">
                        <label class="w-28">Поиск</label>
                        <input class="input sm:ml-2" type="text" v-model="search_param">
                    </div>
                    <p class="bookmark-modal-title text-gradient mr-auto">Инструменты</p>
                    <button class="mt-2 ml-2 mr-auto" @click="pageNumber = 0;GetData()">Запросить данные заново</button>
                    <button class="mt-2 ml-2 mr-auto" @click="$root.ShowModal('#NewTheme')">Создать новую тему</button>
                </div>
            </div>
            <div class="bookmark-navbar">
                <div class="bookmark-link" @click="$root.ToggleBookmark('#themes_adjustments')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z" />
                    </svg>
                </div>
            </div>
        </div>

        <div class="flex flex-row items-end justify-between mt-4 w-[90%] max-w-5xl mx-auto fade">
            <div class="flex flex-row items-center justify-center background rounded-t-lg ml-3 py-2 px-3 fade">
                <p>С</p>
                <p class="ml-2">{{pageNumber * elementNumber + 1}}</p>
                <p class="ml-2">по</p>
                <p class="ml-2">{{pageNumber * elementNumber + themes.length}}</p>
                <p class="ml-2"><b class="text-gradient">Всего:</b> {{themeCount}}</p>
            </div>
            <div class="flex flex-row items-center justify-center background rounded-t-lg mr-3 py-2 px-3 fade">
                <button @click="Back">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
                    </svg>
                </button>
                <p>{{pageNumber + 1}}</p>
                <p class="ml-2">из</p>
                <p class="ml-2">{{pagesCount}}</p>
                <button @click="Forward">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
        </div>

        <div class="card py-0 w-[90%] max-w-5xl mx-auto overflow-auto fade" style="max-height: calc(100vh - 10rem)">
            <table class="sys-table">
                <thead>
                    <th>№</th>
                    <th v-if="$root.HasRole($store.state.adminRole)">ID</th>
                    <th class="w-full">Название</th>
                    <th class="w-6"></th>
                    <th class="w-6"></th>
                </thead>
                <tbody>
                    <tr v-for="(theme, index) in themes" :key="'t_'+index">
                        <th>{{pageNumber * elementNumber + index + 1}}</th>
                        <td class="text-center" v-if="$root.HasRole($store.state.adminRole)">{{theme.id}}</td>
                        <td class="text-center">{{theme.title}}</td>
                        <th>
                            <button class="text-blue-600" @click="currentTheme = index;$root.ShowModal('#ChangeTheme')">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                </svg>
                            </button>
                        </th>
                        <th>
                            <button class="text-red-600" @click="currentTheme = index;$root.ShowModal('#DeleteTheme')">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                                </svg>
                            </button>
                        </th>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="modal dark:text-white" id="NewTheme" @click="$root.HideModal('#NewTheme')">
        <form class="modal-dialog" @submit="NewTheme" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Новая тема</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#NewTheme')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Название <b class="text-red-600">*</b></label>
                    <input type="text" class="input max-w-md sm:ml-auto" ref="theme_title">
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="reset" class="modal-dialog-footer-button" @click="$root.HideModal('#NewTheme')">Отмена</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#NewTheme')">Сохранить</button>
            </div>
        </form>
    </div>

    <div class="modal dark:text-white" id="ChangeTheme" @click="$root.HideModal('#ChangeTheme')">
        <form class="modal-dialog" @submit="ChangeTheme($event, currentTheme)" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Изменение темы</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#ChangeTheme')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body" v-if="currentTheme !== null">
                <div class="form-group">
                    <input type="text" class="input max-w-md" placeholder="Название" :value="themes[currentTheme].title" ref="change_theme_title">
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="reset" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeTheme')">Отмена</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeTheme')">Изменить</button>
            </div>
        </form>
    </div>

    <div class="modal dark:text-white" id="DeleteTheme" @click="$root.HideModal('#DeleteTheme')">
        <div class="modal-dialog" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Удаление темы</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#DeleteTheme')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body flex flex-col items-center">
                <p class="text-warning animate-pulse">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-28 w-28" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                    </svg>
                </p>
                <p class="subtitle text-center">Вы действительно хотите удалить тему?</p>
            </div>
            <div class="modal-dialog-footer">
                <button class="modal-dialog-footer-button" @click="$root.HideModal('#DeleteTheme')">Отмена</button>
                <button class="modal-dialog-footer-button" @click="$root.HideModal('#DeleteTheme');DeleteTheme(currentTheme)">Удалить</button>
            </div>
        </div>
    </div>
</template>

<script>
import Navigation from '@/components/Navigation'

export default {
    components: {
        Navigation
    },
    data() {
        return {
            socket: null,
            search_param: "",
            elementNumber: 25,
            pageNumber: 0,
            themeCount: 0,
            pagesCount: 0,
            navigationKey: "nav",
            title: "Список тем",
            themes: [],
            currentTheme: null,
        }
    },
    methods: {
        SetTitle() {
            document.title = `Samgk Служба заботы - ${this.title}`
        },
        Forward() {
            this.pageNumber = this.pageNumber >= this.pagesCount - 1 ? 0 : this.pageNumber + 1
            this.GetData()
        },
        Back() {
            this.pageNumber = this.pageNumber <= 0 ? this.pagesCount - 1 : this.pageNumber - 1
            this.GetData()
        },
        ClearParams() {
            this.search_param = ""
        },
        async GetData() {
            this.$root.StartLoading()
            let res = await fetch(this.$store.state.supportApiAddr + `/v1.0/themes/list?limit=${this.elementNumber}&skip=${this.pageNumber * this.elementNumber}&search=${this.search_param}`, {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
                credentials: "include"
            })
            .then(response => {return response.json()})
            .catch(error => {
                this.$root.Fatal()
            })

            if (this.$root.HandleFetchError(res)) return

            this.themes = res.data.themes

            this.themeCount = res.data.count

            this.pagesCount = Math.ceil(this.themeCount / this.elementNumber)

            this.$root.EndLoading()
        },
        NewTheme(e) {
            e.preventDefault()

            let title = this.$refs.theme_title.value

            fetch(this.$store.state.supportApiAddr + "/v1.0/themes/", {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                credentials: "include",
                body: JSON.stringify({
                    title: title
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                
                this.$root.ShowToast("Тема успешно добавлена", "success")
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        ChangeTheme(e, index) {
            e.preventDefault()

            let title = this.$refs.change_theme_title.value

            fetch(this.$store.state.supportApiAddr + "/v1.0/themes/", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                credentials: "include",
                body: JSON.stringify({
                    id: this.themes[index].id,
                    title: title
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                
                this.$root.ShowToast("Данные темы успешно изменены", "success")
                this.currentTheme = null
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        DeleteTheme(index) {
            this.currentTheme = null
            fetch(this.$store.state.supportApiAddr + "/v1.0/themes/", {
                method: "DELETE",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                credentials: "include",
                body: JSON.stringify({
                    id: this.themes[index].id
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                
                this.$root.ShowToast("Тема успешно удалёна", "success")
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        AddTheme(theme) {
            this.themes.push(theme)
        },
        UpdateTheme(theme) {
            this.themes[this.themes.map((value) => value.id).indexOf(theme.id)] = theme
        },
        RemoveTheme(theme) {
            this.themes.splice(this.themes.map((value) => value.id).indexOf(theme), 1)
        },
        async StartWebsocket() {
            if (this.$route.name !== "Themes" || this.socket !== null || !this.$root.IsServiceEnabled()) return

            let socket = new WebSocket(this.$store.state.wsAddr + "/v1.0/ws")

            let ShowToast = this.$root.ShowToast
            let token = this.$root.GetWSAuthData()

            let AddTheme = this.AddTheme
            let UpdateTheme = this.UpdateTheme
            let RemoveTheme = this.RemoveTheme

            socket.onopen = () => {
                socket.send(token)
            }

            socket.onmessage = function(event) {
                let data = JSON.parse(event.data)

                switch (data.type) {
                    case "new_theme":
                        AddTheme(data.data)
                        break;
                    case "updated_theme":
                        UpdateTheme(data.data)
                        break;
                    case "removed_theme":
                        RemoveTheme(data.data)
                        break;
                }
            }

            socket.onclose = () => {setTimeout(() => {this.StartWebsocket()}, 10000)}

            socket.onerror = function(event) {
                ShowToast("Не удалось установить соединение с сервером. Подгрузка данных в реальном времени невозможна", "warning")
            }

            this.socket = socket
        },
    },
    beforeUnmount() {
        if (this.socket !== null) this.socket.close()
    },
    mounted() {
        if (this.$root.fatal) return
        this.SetTitle()
        this.$root.StartLoading()
        this.$root.UpdateToken()
        this.$root.GetRoles().then(()=>{
            this.$root.EndLoading()
            if (!(this.$root.HasRole(this.$store.state.adminRole) || this.$root.HasRole(this.$store.state.mainOperatorRole))) {
                setTimeout( () => { this.$root.ShowToast("У вас нет прав на посещение данного раздела", "error", 8000) }, 1000 )
                this.$router.push({name: 'Home'})
                return
            }

            this.GetData()

            setTimeout(()=> {
                this.$root.StartWebsocket()
                this.StartWebsocket()
            }, 100)
        })
    }
}
</script>